import React from "react";
import {
  InstagramOutlined,
  ImportOutlined,
  AlertOutlined,
  NodeIndexOutlined,
  FolderOpenOutlined,
  BookOutlined,
  LockOutlined,
  AimOutlined,
  FireOutlined,
  GlobalOutlined,
  FundOutlined,
  FileDoneOutlined,
  UsergroupAddOutlined,
  TeamOutlined,
  SettingOutlined
} from '@ant-design/icons';

import MessagePrompt from './messagePrompt'


// label 菜单名称
// key 菜单主键 用于路由跳转
// icon 菜单图标
// children 子菜单 数组
// parent 父级菜单key
function getItem (label, key, icon, children, parent = '', permissionkey) {
  return { label, key, icon, children, parent, permissionkey };
}
// 文本，当前key,图标，下级，父级key，权限key 
export const MenuList = [
  // getItem('数据监控', '/data_monitor', <FundOutlined />, '', '', ''),
  getItem('巡检直播', '/inspection_live_broadcast', <InstagramOutlined />, '', '', ''),
  getItem('航线列表', 'shipping_line', <NodeIndexOutlined />, [
    getItem('常规巡检', '/shipping_line/routine', '', '', 'shipping_line', 1),
    getItem('高危巡检', '/shipping_line/leak', '', '', 'shipping_line', 31),
    getItem('综合巡检', '/shipping_line/comprehensive', '', '', 'shipping_line', 66),
    getItem('定点巡检', '/shipping_line/precise', '', '', 'shipping_line', 44),
  ], ''),
  getItem(<MessagePrompt type={'4'} count={0} />, '/abnormal_troubleshooting', <AlertOutlined />, '', '', 14),//异常排查
  getItem(<MessagePrompt type={'2'} count={0} />, '/conventional_risks', <AimOutlined />, '', '', 19),//常规风险
  getItem(<MessagePrompt type={'3'} count={0} />, '/leakage_risk', <FireOutlined />, '', '', 90),//高危风险
  getItem('常规巡检记录', '/regular_inspections_record', <FolderOpenOutlined />, '', '', 25),
  getItem('高危巡检记录', '/leak_inspections_record', <FolderOpenOutlined />, '', '', 98),
  getItem('综合巡检记录', '/comprehensive_inspections_record', <FolderOpenOutlined />, '', '', 110),
  getItem('定点巡检记录', '/designated_inspections_record', <FolderOpenOutlined />, '', '', 104),
  getItem('巡检报告', '/inspection_report', <FileDoneOutlined />, '', '', 29),
  getItem('巡检飞手', '/inspection_pilots', <UsergroupAddOutlined />, '', '', ''),
  getItem('风险处理员', '/risk_handlers', <TeamOutlined />, '', '', ''),
  getItem('管道上帝图', '/pipeline_gad_map', <GlobalOutlined />, '', '', ''),
  // getItem('用户手册', '/user_manual', <BookOutlined />, '', '', ''),
  // getItem('权限设置', '/permission_settings', <SettingOutlined />, '', '', ''),
  getItem('退出登录', '/login', <ImportOutlined />, '', '', ''),
];